<template>
    <paper class="driver-expense-payment">
        <el-tabs v-model="activeName">
            <el-tab-pane name="driverExpenseSplit" label="司机运费支付">
                <driver-expense-split @changeTab="handleChangeTab"></driver-expense-split>
            </el-tab-pane>
            <el-tab-pane name="paymentRecord" label="支付记录">
                <payment-record></payment-record>
            </el-tab-pane>
            <el-tab-pane name="driverExpenseUnfreeze" label="供应商账单费用释放">
                <driver-expense-unfreeze></driver-expense-unfreeze>
            </el-tab-pane>
            <el-tab-pane name="accountBalance" label="美的付账户余额">
                <account-balance v-if="activeName === 'accountBalance'"></account-balance>
            </el-tab-pane>
        </el-tabs>
    </paper>
</template>

<script>
import paper from '@/components/core/paper/Paper';
import bigDataLog from '@/utils/bigDataLog';
export default {
    name: 'DriverExpensePayment',
    components: {
        paper,
        driverExpenseSplit: () => import('./components/driverExpenseSplit/Index.vue'),
        paymentRecord: () => import('./components/paymentRecord/Index.vue'),
        driverExpenseUnfreeze: () => import('./components/driverExpenseUnfreeze/Index.vue'),
        accountBalance: () => import('./components/accountBalance/Index.vue')
    },
    data () {
        return {
            activeName: 'driverExpenseSplit'
        };
    },
    methods: {
        handleChangeTab (tabName) {
            this.activeName = tabName;
        }
    },
    watch: {
        activeName: {
            handler(newVal) {
                // 根据不同的tab添加对应的埋点
                const trackingMap = {
                    driverExpenseSplit: 'bigData-btn-driver-expense-split-tab',
                    paymentRecord: 'bigData-btn-payment-record-tab',
                    driverExpenseUnfreeze: 'bigData-btn-driver-expense-unfreeze-tab',
                    accountBalance: 'bigData-btn-account-balance-tab'
                };

                if (trackingMap[newVal]) {
                    // 这里添加实际的埋点调用
                    bigDataLog.sendDetailMessageByKey(trackingMap[newVal]);
                }
            },
            immediate: true
        }
    }
};
</script>

<style lang='less' scoped>
.driver-expense-payment{
    padding-top: 0px;

    .el-tabs__header{
        margin: 0 0 6px;
    }

   ::v-deep .el-tabs__item {
        padding: 0 12px;
    }

    /deep/.otp-table {
        .el-table {
            min-height: calc(~'100vh - 210px') !important;
            max-height: calc(~'100vh - 210px') !important;
            .el-table__fixed {
                height: calc(100% - 14px) !important;
            }
        }
    }
}
</style>
